"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var legacyApplyMiddleware_1 = require("./legacyApplyMiddleware");
var globalContext_1 = require("../globalContext");
function dispatch(action, actionType, args, actionContext) {
    globalContext_1.getGlobalContext().legacyInDispatch++;
    mobx_1.action(actionType ? actionType : '(anonymous action)', legacyApplyMiddleware_1.dispatchWithMiddleware.bind(null, action, actionType, args, actionContext))();
    globalContext_1.getGlobalContext().legacyInDispatch--;
}
exports.default = dispatch;
